import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { popularsData } from '../../utils/data';
import { TigerPawButton } from '../../components/Buttons/TigerPawButton';
import TermsModal from '../../components/TermsModal/TermsModal';
import BookingForm from '../../components/BookingForm/BookingForm';
import './PackageDetails.css';

const DatasDetails = () => {
  const [showModal, setShowModal] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const { id } = useParams();
  const datas = popularsData.find(p => p.id === parseInt(id));
  
  console.log('Package Data:', datas); // Add this line to debug
  console.log('Hero Image:', datas?.heroImage); // Add this line to debug

  const getPackageDescription = (packageId) => {
    switch(packageId) {
      case 1:
        return {
          title: "1N/2D Safari Special",
          description: "Experience the wilderness of Jim Corbett with a perfect mix of adventure & relaxation."
        };
      case 2:
        return {
          title: datas.title,
          description: "Experience the wild heart of Jim Corbett National Park at the iconic Dhikala Zone. This exclusive package offers an immersive wildlife experience in India's oldest national park, famous for its Bengal tigers, Asian elephants, and diverse birdlife."
        };
      // Add more cases for other packages
      default:
        return {
          title: datas.title,
          description: datas.description || "Experience the wild heart of Jim Corbett National Park."
        };
    }
  };

  const packageContent = getPackageDescription(parseInt(id));

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  if (!datas) {
    return <div className="container py-5">Datas not found</div>;
  }

  // Styles for Package Highlights section
  const highlightsStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '30px'
  };

  const highlightsList = {
    listStyle: 'none',
    padding: 0,
    margin: 0
  };

  const highlightItem = {
    padding: '12px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    borderBottom: '1px solid #eee'
  };

  const infoCardStyle = {
    background: '#fff',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    marginTop: '1.5rem'
  };

  const infoItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #eee'
  };

  const infoIconStyle = {
    fontSize: '20px',
    color: '#fe4e37',
    marginRight: '15px',
    width: '24px'
  };

  const infoTextStyle = {
    color: '#4f5e71',
    fontSize: '16px'
  };

  const infoLabelStyle = {
    fontWeight: 'bold',
    marginRight: '8px',
    color: '#333'
  };

  const cardStyle = {
    background: '#fff',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    marginBottom: '1.5rem'
  };

  const bookNowButtonStyle = {
    backgroundColor: '#D4AF37', // Golden color matching your theme
    border: 'none',
    width: '100%',
    marginTop: '1rem',
    padding: '12px',
    borderRadius: '4px',
    color: '#fff',
    fontWeight: '500',
    textDecoration: 'none',
    display: 'inline-block',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    fontSize: '16px'
  };

  const priceStyle = {
    fontSize: '2rem',
    color: '#333', // Changed to dark color
    fontWeight: 'bold',
    marginBottom: '1rem',
    fontFamily: 'var(--fontFamily1)'
  };

  const itineraryStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    marginBottom: '2rem'
  };

  const dayBoxStyle = {
    backgroundColor: '#f8f9fa',
    padding: '1.5rem',
    borderRadius: '8px',
    marginBottom: '1.5rem',
    border: '1px solid #e9ecef',
    transition: 'all 0.3s ease'
  };

  const dayTitleStyle = {
    color: '#D4AF37',
    fontSize: '1.5rem',
    marginBottom: '1rem',
    fontFamily: 'var(--fontFamily1)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const bulletPointStyle = {
    listStyleType: 'disc',
    color: '#D4AF37',
    paddingLeft: '20px',
    marginBottom: '0'
  };

  const activityItemStyle = {
    marginBottom: '12px',
    color: '#4f5e71',
    fontSize: '1rem'
  };

  const termsButtonStyle = {
    backgroundColor: '#D4AF37',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: 'fit-content'
  };

  return (
    <div style={{ backgroundColor: '#F8F6F1' }}>  {/* Changed page background to #F8F6F1 */}
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${datas.heroImage || datas.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          minHeight: '300px',
          color: '#fff',
        }}
      >
        <div
          style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
        <Container style={{ position: 'relative', zIndex: 1, paddingTop: '100px' }}>
          {/* Removed both title and location */}
        </Container>
      </div>

      {/* Main Content */}
      <Container className="py-5">
        <Row>
          {/* Left Content */}
          <Col lg={8}>
            <div>
              {/* Overview */}
              <div className="mb-5">
                <h2>{packageContent.title}</h2>
                <p>{packageContent.description}</p>
              </div>

              {/* Package Highlights - Styled directly in JSX */}
              <div style={highlightsStyle}>
                <h2 style={{ marginBottom: '20px', color: '#333' }}>Package Highlights</h2>
                <ul style={highlightsList}>
                  {datas.highlights.map((highlight, index) => (
                    <li key={index} style={index === datas.highlights.length - 1 
                      ? { ...highlightItem, borderBottom: 'none' } 
                      : highlightItem}>
                      <TigerPawButton />
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Itinerary Section */}
              <div style={itineraryStyle}>
                <h2 style={{
                  fontSize: '28px',
                  color: '#333',
                  marginBottom: '25px',
                  fontFamily: 'var(--fontFamily1)'
                }}>
                  Tour Itinerary
                </h2>

                {datas.itinerary.map((day, index) => (
                  <div key={index} style={dayBoxStyle}>
                    <h3 style={dayTitleStyle}>
                      <i className="bi bi-calendar-event"></i>
                      {`Day ${index + 1}`}
                    </h3>
                    <ul style={bulletPointStyle}>
                      {/* Split the description into bullet points */}
                      {day.des.split('. ').filter(item => item.trim()).map((item, i) => (
                        <li key={i} style={activityItemStyle}>
                          {item.trim()}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* Removed terms and conditions button and modal */}
            </div>
          </Col>

          {/* Right Sidebar */}
          <Col lg={4}>
            {/* Price Card - Modified to show included items from data */}
            <div style={cardStyle}>
              <h3 style={{ 
                fontSize: '24px', 
                color: '#333',
                marginBottom: '20px',
                fontFamily: 'var(--fontFamily1)'
              }}>
                Package Includes:
              </h3>
              <div>
                <ul style={{ 
                  listStyle: 'none', 
                  paddingLeft: 0,
                  marginBottom: '20px'
                }}>
                  {datas.included.map((item, index) => (
                    <li key={index} style={{ 
                      padding: '8px 0',
                      color: '#4f5e71'
                    }}>
                      <i className="bi bi-check2" style={{ 
                        color: '#D4AF37',
                        marginRight: '10px'
                      }} /> 
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <button 
                style={bookNowButtonStyle}
                onClick={() => setShowBookingForm(true)}
              >
                Book Now
              </button>
            </div>

            {/* Package Info Card */}
            <div style={infoCardStyle}>
              <h3 style={{ 
                fontSize: '24px', 
                color: '#333', 
                marginBottom: '20px',
                fontFamily: 'var(--fontFamily1)'
              }}>
                Package Info
              </h3>
              
              <div style={infoItemStyle}>
                <i className="bi bi-clock" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Duration:</span>
                  {datas.days}
                </div>
              </div>
{/* 
              <div style={infoItemStyle}>
                <i className="bi bi-people" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Group Size:</span>
                  Max 6 people
                </div>
              </div> */}

              <div style={infoItemStyle}>
                <i className="bi bi-calendar3" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Available:</span>
                  Contact us for availability
                </div>
              </div>

              <div style={infoItemStyle}>
                <i className="bi bi-geo-alt" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Location:</span>
                  {datas.location}
                </div>
              </div>

              <div style={infoItemStyle}>
                <i className="bi bi-tag" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Category:</span>
                  {datas.category.join(', ')}
                </div>
              </div>

              <div style={{ ...infoItemStyle, borderBottom: 'none' }}>
                <i className="bi bi-star-fill" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Rating:</span>
                  {datas.rating}/5 ({datas.reviews} reviews)
                </div>
              </div>
            </div>

            {/* Add-ons Card */}
            {datas.addOns && datas.addOns.length > 0 && (
              <div style={{
                ...cardStyle,
                marginTop: '1.5rem'
              }}>
                <h3 style={{ 
                  fontSize: '24px', 
                  color: '#333',
                  marginBottom: '20px',
                  fontFamily: 'var(--fontFamily1)'
                }}>
                  Available Add-ons:
                </h3>
                <div>
                  <ul style={{ 
                    listStyle: 'none', 
                    paddingLeft: 0,
                    marginBottom: '20px'
                  }}>
                    {datas.addOns.map((item, index) => (
                      <li key={index} style={{ 
                        padding: '8px 0',
                        color: '#4f5e71'
                      }}>
                        <i className="bi bi-check2" style={{ 
                          color: '#D4AF37',
                          marginRight: '10px'
                        }} /> 
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Need Help Card */}
            <div style={{ ...infoCardStyle, marginTop: '1.5rem' }}>
              <h3 style={{ 
                fontSize: '24px', 
                color: '#333', 
                marginBottom: '20px',
                fontFamily: 'var(--fontFamily1)'
              }}>
                Need Help?
              </h3>
              <div style={infoItemStyle}>
                <i className="bi bi-telephone" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Call us:</span>
                  +91 8979411128 
                </div>
              </div>
              <div style={{ ...infoItemStyle, borderBottom: 'none' }}>
                <i className="bi bi-envelope" style={infoIconStyle}></i>
                <div style={infoTextStyle}>
                  <span style={infoLabelStyle}>Email:</span>
                  corbettaura15@gmail.com
                </div>
              </div>
            </div>

            {/* Terms & Conditions Button */}
            <button 
              style={{
                backgroundColor: 'transparent',
                color: '#D4AF37',
                border: '2px solid #D4AF37', // Golden border
                padding: '10px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                justifyContent: 'center',
                boxShadow: '0 0 0 1px #D4AF37', // Additional golden outline for more prominent border
              }}
              onClick={handleShow}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#D4AF37';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.border = '2px solid #D4AF37';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#D4AF37';
                e.target.style.transform = 'translateY(0)';
                e.target.style.border = '2px solid #D4AF37';
              }}
            >
              <i className="bi bi-file-text"></i>
              View Terms & Conditions
            </button>

            <TermsModal 
              show={showModal} 
              handleClose={handleClose}
            />
          </Col>
        </Row>
      </Container>

      {/* Booking Form Modal */}
      <Modal 
        show={showBookingForm} 
        onHide={() => setShowBookingForm(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Book Your Package</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BookingForm packageDetails={datas} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DatasDetails;
